var map = {
	"./dv_msg_de.json": 2056,
	"./dv_msg_en.json": 2057,
	"./dv_msg_es.json": 2058,
	"./dv_msg_fr.json": 2059,
	"./dv_msg_it.json": 2060,
	"./dv_msg_ja.json": 2061,
	"./dv_msg_nl.json": 2062,
	"./dv_msg_pt.json": 2063,
	"./dv_msg_zh.json": 2064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2055;